export default __webpack_public_path__ + "static/media/Snd_Try1.d282e14d.mp3";